import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import { InitiateProcessAction } from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as GC from "../../../../common/common";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";
import { CAT_WP_CONST } from "../../../../../constants/ActionEnums/CatActionEnums";

class SelecterenDirectievoerder extends React.Component {
  constructor(props) {
    super(props);
    this.state = { directievoerder: "", directievoerderText: "" };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    var index = event.nativeEvent.target.selectedIndex;

    this.setState({
      directievoerder: event.target.value,
      directievoerderText: event.nativeEvent.target[index].text,
    });
  }

  async handleSubmit() {
    $("#cover-spin").show(0);

    // //** tüm ilişkileri getir */
    // let relations = await omnimap.GetRelationAction(
    //   [window.$catalog_work_plans_selectedIds],
    //   1,
    //   30,
    //   window.$catalog_management_units_token
    // );

    // //** rolü "Directievoerder" olanları filtrele */
    // if (relations.meta.total_found > 0) {
    //   var directievoerder = relations.data.filter(
    //     (user) => user.role === "Directievoerder"
    //   );
    //
    //   //** tüm "Directievoerder" ları sil */
    //   for (let i = 0; i < directievoerder.length; i++) {
    //     const user = directievoerder[i];
    //     await omnimap.DeleteRelationAction(
    //       user.identification,
    //       window.$catalog_management_units_token
    //     );
    //   }
    // }
    // const activity_id = "0f2c4cd8-bd15-48d9-b66b-6292ace8881f"
    // const selected = GetSelected()

    // await omnimap.StartActivityFlowAction(activity_id, selected)


    //** save directievoerder
    // const model = {
    //   directievoerder: {
    //     identification: this.state.directievoerder,
    //     display: [
    //       {
    //         path: "$.alias",
    //         value: this.state.directievoerderText,
    //       },
    //     ],
    //   },
    // };

    const model = {
      action: CAT_WP_CONST.SELECT_DIRECTOR,
      directievoerder_identification: this.state.directievoerder,
      identifications: GetSelected()
    }
    InitiateProcessAction(model, CAT_WP_CONST.END_POINT).then(()=>{
      this.submitCallback()
    }).catch(()=>{
      alert('Something went wrong!')
      $("#cover-spin").hide(0);
    })

    // omnimap.InputDataActivityFlowAction(activity_id, selected, model).then(()=>{
    //   this.submitCallback()
    // })

    // await GC.StartActivity(
    //     model,
    //   [window.$catalog_work_plans_selectedIds[0]],
    //   "0f2c4cd8-bd15-48d9-b66b-6292ace8881f",
    //     this.submitCallback,
    //   window.$catalog_management_units_token
    // );
  }

  submitCallback() {
    GC.sleep(1000).then(() => {
      $("#selecteren_directievoerder").modal("hide");
      $("#cover-spin").hide(0);
    });
  }
  async componentDidMount() {
    var that = this;
    $("#selecteren_directievoerder").on(
      "show.bs.modal",
      async function (event) {
        // get User registered roles

        let realtions = await omnimap.GetRelationAction(
          window.$catalog_work_plans_selectedIds[0],
          1,
          30,
          window.$catalog_management_units_token
        );

        // let userRegisteredRoles = await omnimap.GetUserByRoleAction(
        //   1,
        //   6,
        //   "Directievoerder",
        //   window.$catalog_management_units_token
        // );

        // await userRegisteredRoles.data.forEach(async (element) => {
        //   if (element.role === "Directievoerder") {
        //     await that.setState({
        //       directievoerder: element.identification,
        //       directievoerderText: element.alias,
        //     });
        //   }
        // });

        // let userRegisteredRoles = await omnimap.GetRelationAction(
        //   window.$catalog_work_plans_selectedIds[0],
        //   1,
        //   30,
        //   window.$catalog_management_units_token
        // );

        // await userRegisteredRoles.data.forEach(async (element) => {
        //   if (element.role === "Directievoerder") {
        //     await that.setState({
        //       directievoerder:
        //         element.relationships.related_instance.identification,
        //       directievoerderText: element.relationships.related_instance.name,
        //     });
        //   }
        // });

        //** get user managers
        let directievoerders = await omnimap.GetUserByRoleAction(
          1,
          30,
          "Directievoerder",
          window.$catalog_management_units_token
        );
        await CallBackFunctions.DirectievoerderCallbackForCreate(
          directievoerders.data,
          realtions.data
        );
      }
    );
  }

  render() {
    return (
      <div>
        <div
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          id="selecteren_directievoerder"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Selecteren directievoerder</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {/* //**Werkplan directievoerder(manager) */}
                <label>Selecteren directievoerder </label>
                <select
                  class="form-control"
                  id="werkplan-directievoerder"
                  name="directievoerder"
                  value={this.state.directievoerder}
                  onChange={this.handleInputChange}
                ></select>

                <br />
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  id="save-werkplannnnn"
                  className="btn-modal"
                  onClick={this.handleSubmit.bind(this)}
                >
                  Verwerken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SelecterenDirectievoerder;
